export default  {
	id: '',
	name: '',
	property: '',
	children: []
}